import { configureStore, createSlice } from "@reduxjs/toolkit";
import authAPI from "../services/authApi";
import calculatorAPI from "../services/calculatorApi";
import profileAPI from "../services/profileApi";
import uploadAPI from "../services/uploadApi";
import tripAPI from "../services/tripApi";
import sitesAndActivitiesAPI from "../services/sitesAndActivities";

const homeSlice = createSlice({
  name: "home",
  initialState: {},
  reducers: {}
});

const store = configureStore({
  reducer: {
    home: homeSlice.reducer,
    [authAPI.reducerPath]: authAPI.reducer,
    [calculatorAPI.reducerPath]: calculatorAPI.reducer,
    [profileAPI.reducerPath]: profileAPI.reducer,
    [uploadAPI.reducerPath]: uploadAPI.reducer,
    [tripAPI.reducerPath]: tripAPI.reducer,
    [sitesAndActivitiesAPI.reducerPath]: sitesAndActivitiesAPI.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false})
    .concat(authAPI.middleware)
    .concat(calculatorAPI.middleware)
    .concat(profileAPI.middleware)
    .concat(uploadAPI.middleware)
    .concat(tripAPI.middleware)
    .concat(sitesAndActivitiesAPI.middleware)
});

export default store;